
import {
  fork,
  put,
  all,
  call,
  takeEvery,
  select,
} from 'redux-saga/effects'

import {
  get,
  post,
} from 'helpers/RequestUtil'

import {
  FETCH_DESCRIPTION,
  OPEN_DESCRIPTION_EDIT,
  SAVE_DESCRIPTION,
} from './constants'

import {
  fetchDescription as fetchDescriptionAction,
  fetchDescriptionStart,
  fetchDescriptionSuccess,
  fetchDescriptionError,
  closeDescriptionEdit,
  saveDescriptionError,
  setDescriptionObj,
} from './actions'

import {
  overwriteTables,
} from 'containers/Entity/actions'

import { projectDescriptionSourceSelector } from './selectors'

function* fetchDescription({ id }) {
  try {
    yield put(fetchDescriptionStart())
    const data = yield call(
      get,
      `api/fulcrum/projects/${id}/description`
    )
    yield put(overwriteTables(data))
    yield put(fetchDescriptionSuccess())

  } catch(error) {
    console.log(error)
    yield put(fetchDescriptionError(error))
  }
}

function* saveDescription({ payload }){
  try {
    const postRequest = post('project_descriptions', payload)
    yield call(postRequest, `/api/fulcrum/projects/${payload.projectId}/description`)
    yield put(fetchDescriptionAction(payload.projectId))
    yield put(closeDescriptionEdit())
  } catch(error) {
    console.log(error)
    yield put(saveDescriptionError(error))
  }
}

function* openDescriptionEdit(){
  const descriptionObj = yield select(projectDescriptionSourceSelector)
  yield put(setDescriptionObj(descriptionObj))
}

function* handleFetchDescription(action) {
  yield call(fetchDescription, action)
}

function* handleSaveDescription(action) {
  yield call(saveDescription, action)
}

function* handleOpenDescriptionEdit() {
  yield call(openDescriptionEdit)
}

function* watchFetchDescription(){
  yield takeEvery(FETCH_DESCRIPTION, handleFetchDescription)
}

function* watchSaveDescription(){
  yield takeEvery(SAVE_DESCRIPTION, handleSaveDescription)
}

function* watchOpenDescriptionEdit(){
  yield takeEvery(OPEN_DESCRIPTION_EDIT, handleOpenDescriptionEdit)
}

function* loadSagas() {
  yield all([
    fork(watchFetchDescription),
    fork(watchSaveDescription),
    fork(watchOpenDescriptionEdit),
  ])
}

export default loadSagas
